import { FormContainer } from "./integration-consult/FormContainer";
import { FormSubmitButton } from "./integration-consult/FormSubmitButton";
import { useState } from "react";

interface ContactSalesFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ContactSalesForm = ({ open, onOpenChange }: ContactSalesFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      onOpenChange(false);
    }, 2000);
  };

  return (
    <FormContainer 
      open={open} 
      onOpenChange={onOpenChange}
      isSubmitting={isSubmitting}
      title="Contact Sales"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Name</label>
            <input 
              type="text" 
              className="w-full p-2 border rounded-md" 
              placeholder="Your Name" 
              required 
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input 
              type="email" 
              className="w-full p-2 border rounded-md" 
              placeholder="your@email.com" 
              required 
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Company</label>
          <input 
            type="text" 
            className="w-full p-2 border rounded-md" 
            placeholder="Company Name" 
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Message</label>
          <textarea 
            className="w-full p-2 border rounded-md h-24" 
            placeholder="Tell us about your needs..."
            required 
          />
        </div>

        <FormSubmitButton 
          isSubmitting={isSubmitting}
          text="Contact Sales"
          loadingText="Sending..."
        />
      </form>
    </FormContainer>
  );
};